var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_detail",
    transform: "translate(0 .238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    transform: "translate(0 -.238)",
    style: {
      fill: "none"
    },
    d: "M0 0h48v48H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_269",
    "data-name": "\\uADF8\\uB8F9 269",
    transform: "translate(4 1.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_347",
    "data-name": "\\uD328\\uC2A4 347",
    className: "cls-2",
    d: "m40.654 38.436-6.011-6.011c-.012-.012-.029-.016-.041-.027a12.085 12.085 0 1 0-1.364 1.451l6 6a1 1 0 1 0 1.415-1.414m-15.436-3.476a9.973 9.973 0 1 1 9.973-9.973 9.985 9.985 0 0 1-9.973 9.973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_348",
    "data-name": "\\uD328\\uC2A4 348",
    className: "cls-2",
    d: "M11.1 29.259H5.706a1.427 1.427 0 0 1 0-2.853h4.829a14.819 14.819 0 0 1-.072-1.42 14.812 14.812 0 0 1 .283-2.861h-5.04a1.427 1.427 0 0 1 0-2.853h5.906a14.738 14.738 0 0 1 2.774-4.281h-8.68a1.427 1.427 0 0 1 0-2.853h12.272a14.641 14.641 0 0 1 2.275-1.032c.185-.072.371-.141.56-.2l.026-.008a12.77 12.77 0 0 1 6.284-.524 14.64 14.64 0 0 1 4.263 1.226V9.285a5.708 5.708 0 0 0-5.706-5.706H5.706A5.707 5.707 0 0 0 0 9.285v28.533a5.707 5.707 0 0 0 5.706 5.706H25.68a5.708 5.708 0 0 0 5.4-3.859.638.638 0 0 0-.811-.827A14.724 14.724 0 0 1 11.1 29.259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_349",
    "data-name": "\\uD328\\uC2A4 349",
    className: "cls-2",
    d: "M35.463 5.728A5.728 5.728 0 0 0 29.739 0h-20.2a5.688 5.688 0 0 0-4.367 2.062h20.947a7.018 7.018 0 0 1 7.018 7.018v3.472a14.784 14.784 0 0 1 2.326 1.832z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_350",
    "data-name": "\\uD328\\uC2A4 350",
    className: "cls-2",
    d: "m20.84 10.893-.026.008.026-.008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_351",
    "data-name": "\\uD328\\uC2A4 351",
    className: "cls-2",
    d: "M31.386 11.782V11.6a14.632 14.632 0 0 0-4.263-1.228 13.278 13.278 0 0 1 4.263 1.413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_352",
    "data-name": "\\uD328\\uC2A4 352",
    className: "cls-2",
    d: "M12.422 19.272a13.32 13.32 0 0 1 2.4-4.281h-.43a14.762 14.762 0 0 0-2.775 4.281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_353",
    "data-name": "\\uD328\\uC2A4 353",
    className: "cls-2",
    d: "M35.463 15.171v-.787a14.784 14.784 0 0 0-2.326-1.832v.371a13.452 13.452 0 0 1 2.326 2.248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDetail);
export default __webpack_public_path__ + "static/media/ic_detail.d6442c6d8d9e959a617b4056301e4613.svg";
export { ForwardRef as ReactComponent };